import React, {Component} from 'react';
import topBar from '../modules/topBar';
import navbar from '../modules/navbar';
import appointmentList from '../modules/appointmentList';

class CasesPageComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
  }

  render() {
  	return (
	    <div id="page-cases">
        <topBar.container/>
        <div className="bottom-container">
          <navbar.container/>
          <div className="main-section">
            <appointmentList.container />
          </div>
        </div>
	    </div>
	  )
  }
}

export default CasesPageComponent;
